export default {
  URL_LENGHT: 36
}
